import React from 'react';
import gs from '../global.css';
const CSAEPolicy = () => {
    const isDesktop = window.innerWidth > window.innerHeight;
    return (React.createElement("div", { className: gs.main },
        React.createElement("div", { className: gs.screenContainer, style: {
                paddingTop: isDesktop ? '15vh' : '13vh',
                paddingLeft: '5%',
                paddingRight: '5%',
                lineHeight: 1.6,
                display: 'flex',
                flexDirection: 'column',
                gap: '1.5rem',
                maxWidth: 800,
                margin: '0 auto',
            } },
            React.createElement("h1", null, "Child Sexual Abuse and Exploitation (CSAE) Prevention Standards"),
            React.createElement("p", null,
                "At ",
                React.createElement("strong", null, "Sticknet"),
                ", we are committed to preventing the spread of child sexual abuse and exploitation (CSAE) material. We strictly prohibit any content or behavior that involves CSAE, and we take immediate action against such violations."),
            React.createElement("h2", null, "1. Zero Tolerance Policy"),
            React.createElement("p", null, "We do not allow any content that depicts or promotes CSAE. Violators will be banned, and content will be reported to relevant authorities."),
            React.createElement("h2", null, "2. User Reporting Mechanism"),
            React.createElement("p", null, "Users can report abusive or inappropriate content through our in-app feedback and reporting system. All reports are reviewed promptly by our moderation team."),
            React.createElement("h2", null, "3. Content Moderation"),
            React.createElement("p", null, "Our team actively monitors flagged content and removes CSAE material immediately. Offending accounts are suspended or permanently banned."),
            React.createElement("h2", null, "4. Cooperation with Authorities"),
            React.createElement("p", null, "We cooperate fully with law enforcement agencies. Confirmed CSAE content or incidents are reported to the appropriate legal and child protection organizations, including the NCMEC when applicable."),
            React.createElement("h2", null, "5. Regular Reviews and Training"),
            React.createElement("p", null, "Moderators and relevant staff receive regular training and updates on detecting and handling CSAE content, aligned with industry standards and best practices."))));
};
export default CSAEPolicy;
